<template>
  <modal name="edit-fuel-station-modal" :height="isMobile ? '100%' : 'auto'" :width="isMobile ? '100%' : '45%'" :scrollable="true" @opened="loadDetail" @closed="resetForm">
    <div class="pt-3 pb-2 pr-4 pl-4 border-gray-100 dark:border-gray-500 dark:bg-gray-900 dark:text-gray-200">
      <h4 class="inline-block w-11/12">İSTASYON DÜZENLE</h4>
      <button class="p-2 w-1/12" @click="$modal.hide('edit-fuel-station-modal')">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <form @submit.prevent="save" class="p-4 bg-white dark:bg-gray-900 text-black dark:text-gray-200 border-gray-200 border-b border-t border-opacity-30 overflow-y-auto h-full pb-20 xl:h-auto xl:pb-3">
      <div class="w-full">
        <diffInput v-model="name" title="İstasyon Adı" type="text" max="255" required />
      </div>

      <div class="grid grid-cols-2 gap-3 mt-3">
        <diffInput v-model="city" title="Şehir" type="text" />
        <diffInput v-model="district" title="İlçe" type="text" />
      </div>

      <div class="grid grid-cols-2 gap-3 mt-3">
        <diffInput v-model="contactPhone" title="Telefon (SMS)" type="text" />
        <diffInput v-model="contactName" title="Yetkili Adı" type="text" />
      </div>

      <div class="grid grid-cols-2 gap-3 mt-3">
        <diffInput v-model="fuelTypes" title="Yakıt Türleri" type="text" placeholder="DIZEL,BENZIN,LPG,ADBLUE" />
        <diffInput v-model="isContracted" title="Anlaşmalı mı?" type="select" :optList="contractedOptions" />
        <!-- Siber ERP firma kodu. Boş bırakılırsa o istasyondan alınan yakıt
             Siber'e yazılamaz; controller "kalıcı hata" verir. -->
        <diffInput v-model="siberFirmaIntId" title="Siber Firma Kodu" type="number" placeholder="Siber'deki firma ID'si" />
      </div>

      <div class="mt-4">
        <GmapItem
          placeHolder="Konum | Adres"
          height="250px"
          @change="(val) => (position = val)"
          :draggable="true"
          :defaultAdress="position.adress"
          :defaultLat="position.lat"
          :defaultLng="position.lng"
        />
      </div>

      <div class="w-full mt-4 text-right">
        <asyncBtn icon="fas fa-check" text="Güncelle" :loadTitle="$t('general.saveButtonLoadTitle')" :loadState="loading" class="w-full" />
      </div>
    </form>
  </modal>
</template>

<script>
import diffInput from "@/components/general/diffInput.vue";
import asyncBtn from "@/components/general/asyncBtn.vue";
import GmapItem from "@/components/general/gmapInput.vue";
import axios from "axios";
import { fuel } from "@/networking/urlmanager";

export default {
  name: "edit-fuel-station-modal",
  components: { diffInput, asyncBtn, GmapItem },
  props: { detail: { type: Object, default: () => ({}) } },
  data() {
    return {
      loading: false,
      name: "",
      city: "",
      district: "",
      contactPhone: "",
      contactName: "",
      fuelTypes: "DIZEL",
      isContracted: 1,
      siberFirmaIntId: null,
      position: { lat: 0, lng: 0, adress: "" },
      contractedOptions: [
        { id: 1, name: "Evet" },
        { id: 2, name: "Hayır" },
      ],
    };
  },
  methods: {
    loadDetail() {
      if (this.detail) {
        this.name = this.detail.name || "";
        this.city = this.detail.city || "";
        this.district = this.detail.district || "";
        this.contactPhone = this.detail.contactPhone || "";
        this.contactName = this.detail.contactName || "";
        this.fuelTypes = this.detail.fuelTypes || "DIZEL";
        this.isContracted = this.detail.isContracted || 1;
        this.siberFirmaIntId = this.detail.siberFirmaIntId || null;
        this.position = {
          lat: parseFloat(this.detail.latitude) || 0,
          lng: parseFloat(this.detail.longitude) || 0,
          adress: this.detail.address || "",
        };
      }
    },
    save() {
      if (this.isEmptyText(this.name)) {
        this.swalBox("warning", this.$t("general.warningTitle"), "Lütfen istasyon adını giriniz!", false, this.$t("general.OkayTitle"));
        return;
      }
      if (!this.position?.lat) {
        this.swalBox("warning", "UYARI!", "Lütfen haritadan bir konum seçin.");
        return;
      }

      this.loading = true;
      axios.post(fuel.stationEdit, {
        id: this.detail.id,
        name: this.name,
        address: this.position.adress,
        city: this.city,
        district: this.district,
        latitude: this.position.lat,
        longitude: this.position.lng,
        contactPhone: this.contactPhone,
        contactName: this.contactName,
        fuelTypes: this.fuelTypes,
        isContracted: this.isContracted,
        siberFirmaIntId: this.siberFirmaIntId || null,
      }, {
        headers: { Authorization: "Bareer " + this.$store.state.userData.token },
      })
        .then(() => {
          this.swalBox("success", this.$t("general.successTitle"), "", false, this.$t("general.OkayTitle")).then(() => {
            this.$emit("refresh", true);
            this.$modal.hide("edit-fuel-station-modal");
          });
        })
        .catch((err) => { this.loading = false; this.errorBox(err.response); });
    },
    resetForm() {
      this.name = "";
      this.city = "";
      this.district = "";
      this.contactPhone = "";
      this.contactName = "";
      this.fuelTypes = "DIZEL";
      this.isContracted = 1;
      this.siberFirmaIntId = null;
      this.position = { lat: 0, lng: 0, adress: "" };
      this.loading = false;
    },
  },
};
</script>
